<template>
  <div id="app">
    <el-card  class="login-container"
    >

      <el-select v-model="qudaoname" placeholder="请选择渠道">
        <el-option
          v-for="item in options1"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <br> <br> <br>
      <el-input
        autosize
        placeholder="输入项目名称"
        v-model="projectname">
      </el-input>
      <br> <br>
      <el-input
        autosize
        placeholder="输入落地页链接"
        v-model="luodiyeurl">
      </el-input>
      <br> <br>
      <el-input
        autosize
        placeholder="输入审核页链接"
        v-model="urlB">
      </el-input>
      <br> <br>

      <el-input
        autosize
        placeholder="落地页名称"
        v-model="name">
      </el-input>
      <el-button type="primary" v-on:click="update()"  :disabled="isDisable" round>创建</el-button>

    </el-card>

  </div>

</template>

<script>
export default {
  name: "qjwf",
  data(){
    return{
      name:'',
      token:'',
      urlB:'',
      luodiyeurl:'',
      projectname:'',
      projectid:'',
      qudaoname:'',
      options1: [

        {
          value: 'vivo',
          label: 'VIVO',

        },  {
          value: 'oppo',
          label: 'OPPO',

        },

      ],

    }
  },
  methods:{
    async update(){


      let parms={
        "projectname":this.projectname,
      }
      if (this.urlB!==''){
        parms.urlB=this.urlB
      }
      await this.addProject(parms)
    },
   //添加项目
    async addProject(parms){
      const config = {
        headers:{
          'X-Token': this.token,
        }
      };
      await this.$axios.post('https://server.qianjiawanfen.top/weixin/project/add',
        {
          "projectname":parms.projectname,
          "showno":"0","detail":"","status":"1","companyid":7,"quick":1
        },config).then(async resp=>
      {
        console.log(resp.data.errmsg)
        if (resp.data.errmsg==="添加错误,重复的项目名字"){
          alert("已经有此项目，将在项目下面添加")
          await this.findid(parms);
          let parms={
            'projectid':this.projectid
          }
          await this.modelGroup(parms)
          await this.addLoudiye2(parms)
          //查询名字，项目id
          //添加落地页
        }else {
          let parms={
            'group_name':resp.data.data.systemprojectinfo.projectname,
            'projectid':resp.data.data.systemprojectinfo.projectid
          }
          await this.modelGroup(parms)
        }

      })
    },
    //添加项目模板
    async modelGroup(parms){

      const config = {
        headers:{
          'X-Token': this.token,
        }
      };
      await this.$axios.post('https://server.qianjiawanfen.top/weixin/modelgroup/add',
        {
          "group_name":parms.group_name,
          "projectid":parms.projectid,
          "detail":"",
          "status":"1",
          "companyid":7,
          "quick":1
        },config).then(async resp=>
      {
        let parms={
          'projectid':resp.data.data.modelgroupdatainfo.projectid,
          'id':resp.data.data.modelgroupdatainfo.id
        }
        await this.addModel(parms)
      })
    },
    //添加模板
    async addModel(parms){
      const config = {
        headers:{
          'X-Token': this.token,
        }
      };
      await this.$axios.post('https://server.qianjiawanfen.top/weixin/model/add',
        {
          "examine_type":1,
          "modelgroup_id":parms.id,
          "modelstyleid":1,
          "name":"1",
          "projectid":parms.projectid,
          "title":"1",
          "status":"1",
          "companyid":7,
          "quick":1
        },config).then(async resp=>
      {
        let parms={
          "projectid":resp.data.data.modeldatainfo.projectid,
          "modelid":resp.data.data.modeldatainfo.id,

        }
        await   this.addLoudiye(parms)
        await   this.addWX(parms)

      })
    },
    //微信分组
    async addWX(parms){
      const config = {
        headers:{
          'X-Token': this.token,
        }
      };
      await this.$axios.post('https://server.qianjiawanfen.top/weixin/weixingroup/add',

      {"projectid":parms.projectid,
        "groupname":this.projectname,
        "showno":"0",
        "detail":"",
        "status":"1",
        "companyid":7,
        "quick":1}
        ,config).then(async resp=>
      {
        let parms={
          "projectid":resp.data.data.modeldatainfo.projectid,
          "modelid":resp.data.data.modeldatainfo.id,

        }
        await   this.addLoudiye(parms)
      })
    },
    //查询项目id
    async findid(parms){
      const config = {
        headers:{
          'X-Token': this.token,
        }
      };
      let vivo=
      {"companyid":7,"startpos":0,"cnt":20,"other":this.projectname,"quick":1}

      await this.$axios.post('https://server.qianjiawanfen.top/weixin/project/list',
        vivo ,config).then( async resp=>
      {
        this.projectid=resp.data.data.systemprojectarray[0].projectid
      })
    },
    //chongfu -
    async addLoudiye2(parms){
      const config = {
        headers:{
          'X-Token': this.token,
        }
      };
      let vivo={
        "projectid":parms.projectid,
        "qudaoname":this.qudaoname,
        "luodiyeurl":this.luodiyeurl,
        "modelid":27,
        "yumingid":8,
        "jumpwxtype":0,
        "jumpweixinid":0,
        "detail":this.name,
        "status":"1",
        "companyid":7,
        "quick":1
      }
      if (this.qudaoname==="vivo"){
        vivo.advertiseid=25
      }else if(this.qudaoname==="oppo") {
        vivo.advertiseid=31
      }
      await this.$axios.post('https://server.qianjiawanfen.top/weixin/luodiye/add',
        vivo ,config).then( async resp=>
      {
        let parms={
          id:resp.data.data.luodiyeinfo.id
        }
        alert('<script type="text/javascript" src="' + resp.data.data.luodiyeinfo.configstr + '"><' + '/script>');
        await this.edithuochuan(parms)
        await this.editLoudiye(parms)
      })
    },
    //添加落地页
    async addLoudiye(parms){
      const config = {
        headers:{
          'X-Token': this.token,
        }
      };
      let vivo={
        "projectid":parms.projectid,
        "qudaoname":this.qudaoname,
        "luodiyeurl":this.luodiyeurl,
        "modelid":parms.modelid,
        "yumingid":8,
        "jumpwxtype":0,
        "jumpweixinid":0,
        "detail":this.name,
        "status":"1",
        "companyid":7,
        "quick":1
      }
      if (this.qudaoname==="vivo"){
        vivo.advertiseid=25
      }else if(this.qudaoname==="oppo") {
        vivo.advertiseid=31
      }
      await this.$axios.post('https://server.qianjiawanfen.top/weixin/luodiye/add',
        vivo ,config).then( async resp=>
      {
        let parms={
          id:resp.data.data.luodiyeinfo.id
        }
        alert('<script type="text/javascript" src="' + resp.data.data.luodiyeinfo.configstr + '"><' + '/script>');
        await this.edithuochuan(parms)
        await this.editLoudiye(parms)
      })
    },
    //编辑落地页跳转
    async editLoudiye(parms){
      const config = {
        headers:{
          'X-Token': this.token,
        }
      };
      let tiaozhaun={}
      if (this.qudaoname==="vivo"){
        tiaozhaun={"luodiyetiaojianinfo":{"id":parms.id,"luodiyeid":parms.id,"str":"{\"urlB\":\""+this.urlB+"\",\"deviceLimit\":1,\"devices\":[2,3,4,10000],\"browserLimit\":1,\"browsers\":[1,7,13,19,25,32,26,31,20,14,2,3,9,15,21,27,10000,28,22,16,10,4,11,17,23,29,30,12,24,18,6],\"sourceLimit\":0,\"sources\":[],\"ldyParamLimit\":2,\"ldyParams\":\"\",\"ipLimit\":0,\"ips\":\"\",\"cityLimit\":1,\"citys\":\"北京|广州|济南|西安|郑州|深圳|武汉|合肥|成都|南京|杭州|昆明|东莞\",\"timeLimit\":0,\"times\":[],\"conditionType\":1}","companyid":7},"companyid":7,"quick":1}
      }else {
        tiaozhaun={"luodiyetiaojianinfo":{"id":parms.id,"luodiyeid":parms.id,"str":"{\"urlB\":\""+this.urlB+"\",\"deviceLimit\":1,\"devices\":[2,3,4,10000],\"browserLimit\":1,\"browsers\":[1,7,13,19,25,31,32,26,20,14,2,3,15,9,21,27,10000,28,22,16,10,4,5,11,17,23,29,30,24,12,18],\"sourceLimit\":0,\"sources\":[],\"ldyParamLimit\":2,\"ldyParams\":\"\",\"ipLimit\":0,\"ips\":\"\",\"cityLimit\":1,\"citys\":\"福州|沈阳|天津|深圳|广州|中山|东莞|惠州|珠海|呼和浩特|哈尔滨|石家庄|西藏|安徽|杭州|宁波|济南|青岛|长沙|成都|西宁|武汉|南昌|南宁|南京|海口|新疆|昆明|长春|北京|贵阳|银川|兰州|重庆|西安|上海|郑州|太原|香港|澳门|台湾|宿迁\",\"timeLimit\":0,\"times\":[],\"conditionType\":1}","companyid":7},"companyid":7,"quick":1}
      }
      await this.$axios.post('https://server.qianjiawanfen.top//weixin/luodiyetjtz/edit',
        tiaozhaun,config).then(resp=>
      {
                      alert("全部完成")
      })
    },
    //编辑回传
    async edithuochuan(parms){
      const config = {
        headers:{
          'X-Token': this.token,
        }
      };
      let huichuan={}
      if (this.qudaoname==="vivo"){
        huichuan={"luodiyetuibehaviorinfo": {"id":parms.id,"luodiyeid":parms.id, "operation_str":"{\"wx_open_click\":\"BUTTON_CLICK\"," + "\"chang_an_erweima\":\"IDENTIFY_CODE\",\"api_add_friend\":\"SUBMIT\",\"first_send_msg\":\"DIALOGUE_MPA\"}","random_huichuan_lv":100,"youlan_time":0, "youlan_shendu":0,"from":"","same_user":1,"companyid":7}, "companyid":7,"quick":1}
      }else {
        huichuan={"luodiyetuibehaviorinfo":{"id":parms.id,"luodiyeid":parms.id,"operation_str":"{\"wx_open_click\":\"0\",\"chang_an_erweima\":\"101\",\"api_add_friend\":\"101\"}","random_huichuan_lv":100,"youlan_time":0,"youlan_shendu":0,"from":"","same_user":1,"companyid":7},"companyid":7,"quick":1}
      }
      await this.$axios.post('https://server.qianjiawanfen.top/weixin/luodiyezhuanhua/edit',
      huichuan
        ,config).then(resp=>
      {
        console.log(resp.data.data)

      })
    }
  },
  created() {
    this.$axios.post('https://server.qianjiawanfen.top/weixin/user/login'
      ,
      {
        "useraccount":"admin@weichi1","password":"1383734cc13db894a26e184e8e66da87","logintype":1,"companyid":7,"quick":1      }).then(resp=>
    {
      console.log(resp.data.data.token)
      this.token=resp.data.data.token
    }

    )
  }
}
</script>

<style scoped>
.login-container {
  border-radius: 15px;
  background-clip: padding-box;
  margin: 90px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}
</style>



// WEBPACK FOOTER //
// src/components/qjwf.vue